<template>
  <div>
    <v-card>
      <v-card-text>
        <v-data-table :headers="headers" :items="getDemosList" :loading="getFetchDemosListLoading" :server-items-length="Number(getDemosListConfig.paginationCount)" :page.sync="options.pagination.page" :options.sync="options.pagination" :footer-props="{itemsPerPageOptions: itemsPerPageOptions}">
          <template v-slot:item.id="{item}">
            <span class="secondary--text">{{ item.id | customPlaceholder('-') }}</span>
          </template>
          
          <template v-slot:item.username="{item}">
            <span>{{ item.username | customPlaceholder('-') }}</span>
          </template>

          <template v-slot:item.password="{item}">
            <span>{{ item.password | customPlaceholder('-') }}</span>
          </template>

          <template v-slot:item.number="{item}">
            <span>{{ item && item.number ? item.number.number : '-' | customPlaceholder('-') }}</span>
          </template>

          <template v-slot:item.creation_timestamp="{item}">
            <span>{{ item.creation_timestamp | formatDate }}</span>
          </template>

          <template v-slot:item.assign_date="{item}">
            <span>{{ item.assign_date | formatDate }}</span>
          </template>

          <template v-slot:item.ceased_date="{item}">
            <span>{{ item.ceased_date | formatDate }}</span>
          </template>

          <template v-slot:item.action="{ item }">
            <LeadLink :leadid="item.lead_id" :disabled="isEmpty(item.lead_id)"/>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import LeadLink from '@/components/Globals/LeadLink';
import { mapMutations, mapActions, mapGetters } from 'vuex';
import { isEmpty } from '@/helpers/shared';

export default {
  components: {
    LeadLink,
  },

  data() {
    return {
      headers: [
        {text: 'Demo ID', sortable: false, value: 'id'},
        {text: 'Status', sortable: false, value: 'status'},
        {text: 'Username', sortable: false, value: 'username'},
        {text: 'Password', sortable: false, value: 'password'},
        {text: 'Number', sortable: false, value: 'number'},
        {text: 'Created', sortable: false, value: 'creation_timestamp'},
        {text: 'Activated', sortable: false, value: 'assign_date'},
        {text: 'Ceased', sortable: false, value: 'ceased_date'},
        {text: '', sortable: false, value: 'action'},
      ],
      options: {
        pagination: {
          page: 1,
          itemsPerPage: 50,
          sortBy: [],
          sortDesc: [],
        },
        queryParams: {},
      },
      itemsPerPageOptions: [5,10,15,25,50],
      isEmpty,
    }
  },

  computed: {
    ...mapGetters('demos', ['getDemosList', 'getFetchDemosListLoading', 'getDemosListConfig']),
  },

  watch: {
    "options.pagination": {
      immediate: false,
      handler() {
        const query = {
          pagination: {
            page: this.options.pagination.page,
            limit: this.options.pagination.itemsPerPage,
          },
          queryParams: { ...this.options.queryParams }
        };

        this.updateDemosListConfigPagination(query);

        if(this.options.queryParams) {
          delete this.options.queryParams;
        }
      },
      deep: true,
    }
  },

  async created() {
    const queryParams = JSON.parse(JSON.stringify(this.$route.query));
    
    if(Object.keys(queryParams).length) {
      this.options.pagination.page = parseInt(queryParams.page);
      this.options.pagination.itemsPerPage = parseInt(queryParams.limit);
      this.options.pagination.sortBy = queryParams.ordering ? [queryParams.ordering] : [];
      this.options.pagination.sortDesc = queryParams.order === 'asc' ? [false] : queryParams.order === 'desc' ? [true] : [true];
      this.options.queryParams = { ...queryParams };
    } else {
      this.options.page = 1;
      this.options.pagination.itemsPerPage = 50;
      this.options.pagination.sortDesc = [true];
    }
  },

  beforeDestroy() {
    this.RESET_DEMOS_STORE();
  },

  methods: {
    ...mapMutations('demos', ['RESET_DEMOS_STORE']),
    ...mapActions('demos', ['updateDemosListConfigPagination']),
  }
}
</script>

<style lang="scss" scoped>

</style>